// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__36gdO","label":"LabeledBox_label__3CHFK"};